export enum NavStepStatusID {
  Unknown = 'unknown',
  NotDone = 'not-done',
  Done = 'done',
  Current = 'current',
}
export class NavStep {
  constructor(
    public name: string = '',
    public routeSecName: string = '',
    public visible: boolean = true,
    public status: NavStepStatus = NavStepStatusID.NotDone,
  ) {
  }
}

export type NavStepStatus = NavStepStatusID.Unknown | NavStepStatusID.NotDone |
  NavStepStatusID.Done | NavStepStatusID.Current;
export interface StepperName {
  overview: string;
  details: string;
  membership: string;
  application: string;
  preferences: string;
  review: string;
  confirmation: string;
}

export const Step: StepperName = {
  overview: 'Overview',
  details: 'Details',
  membership: 'Membership',
  application: 'Application',
  preferences: 'Preferences',
  review: 'Review',
  confirmation: 'Confirmation',
}

export interface SectionName {
  overview: string;
  details: string;
  membership: string;
  application: string;
  preferences: string;
  review: string;
  confirmation: string;
}

export const Section: SectionName = {
  overview: 'overview',
  details: 'details',
  membership: 'membership',
  application: 'application',
  preferences: 'preferences',
  review: 'review',
  confirmation: 'confirmation',
}
